import { Stack, Text } from '@mantine/core';
import { IconInboxOff } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../../../contexts/profile';

export default function RepliesEmpty() {
	const { t } = useTranslation();
	const { profile } = useProfile();

	return (
		<Stack
			w="100%"
			py="2rem"
			pt="2rem"
			align="center"
			justify="center"
		>
			<IconInboxOff size="4rem" stroke={0.75} />

			<Stack gap="md">
				<Stack gap="xs" align="center">
					<Text ta="center" lh="1" fz="1.6rem" ff="var(--ff-title)">
						{t('replies.empty.title')}
					</Text>
					<Text fz="xs" fw="200" ta="center" px="6rem">
						{t('replies.empty.subtitle', { username: profile?.username ?? '' })}
					</Text>
				</Stack>
			</Stack>
		</Stack>
	);
}
